import { Component, EventEmitter, forwardRef, Input, Output, ViewChild } from '@angular/core';
import {
  ControlValueAccessor,
  FormControl,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ValidationErrors,
} from '@angular/forms';
import { Calendar } from 'primeng/calendar';

@Component({
  selector: 'hub-datepicker',
  templateUrl: './hub-datepicker.component.html',
  styleUrls: ['./hub-datepicker.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => HubDatepickerComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => HubDatepickerComponent),
      multi: true,
    },
  ],
})
export class HubDatepickerComponent implements ControlValueAccessor {
  @Input() dateFormat: string = 'D, dd M yy';
  @Input() placeholder: string = '';
  @Input() label: string = null;
  @Input() labelColor?: string = null;
  @Input() showTime: boolean = false;
  @Input() minDate?: Date | null = null;
  @Input() maxDate?: Date | null = null;
  @Input() required?: boolean = false;
  @Input() icon: string = 'calendar-date';
  @Input() iconColor?: string = '#6B728C';
  @Input() timeOnly?: boolean = false;
  @Input() stepMinute: number = 15;
  @Input() disabledDates: Date[] = [];
  @Input() showOtherMonths: boolean = true;
  @Input() disabled: boolean = false;
  @Output() onDateChanged = new EventEmitter<Date | null>();
  @Output() onMonthChange = new EventEmitter<any>();

  @ViewChild('calendarRef') calendarRef!: Calendar;

  value: Date | null = null;

  onChange = (value: any) => { };
  onTouched = () => { };

  writeValue(value: Date | null): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  validate(control: FormControl): ValidationErrors | null {
    return control.errors;
  }

  handleDateChange(event: any) {
    console.log('Date changed:', event);
    this.value = event;
    this.onChange(event);
    this.onDateChanged.emit(event);
  }

  handleMonthChange(event: any) {
    this.onMonthChange.emit(event);
  }

  focus(): void {
    if (this.calendarRef) {
      setTimeout(() => {
        this.calendarRef.showOverlay();
      }, 0);
    }
  }

  show(): void {
    if (this.calendarRef) {
      this.calendarRef.showOverlay();
    }
  }

  hide(): void {
    if (this.calendarRef) {
      this.calendarRef.hideOverlay();
    }
  }
}
